class LoansDetailCollapseController {

  constructor() {
    this.moreInfoIsVisible = false;
  }

  $onInit() {
    if (this.opened === true) this.moreInfoIsVisible = true;
  }

  toggleMoreInfo() {
    this.moreInfoIsVisible = !this.moreInfoIsVisible;
  }

  getClasses() {
    return {
      'more-info-text-is-show': this.moreInfoIsVisible === true , 
      'more-info-text-is-hide': this.moreInfoIsVisible !== true 
    };
  }
}

export default LoansDetailCollapseController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailCollapse/loansDetailCollapse.controller.js